import {GroupedInventoryItem, ItemDTO} from '../../types/Inventory';

export const groupInventoryItems = (items: ItemDTO[]): GroupedInventoryItem[] => {
  const map = new Map<string, GroupedInventoryItem>();

  items.forEach((item, index) => {
    const hasFloat = item.details?.floatValue != null;

    if (hasFloat) {
      const key = `float-${item.itemAssetId ?? 'noid'}-${index}`;
      map.set(key, {
        key,
        items: [item],
        representative: item,
        totalCount: 1,
      });
      return;
    }

    const classId = item.catalog?.classId ?? 'noclass';
    const instanceId = item.catalog?.instanceId ?? 'noinstance';
    const key = `${classId}-${instanceId}`;

    const existing = map.get(key);
    if (existing) {
      existing.items.push(item);
      existing.totalCount += 1;
    } else {
      map.set(key, {
        key,
        items: [item],
        representative: item,
        totalCount: 1,
      });
    }
  });

  return Array.from(map.values());
};